import { createTheme } from "@mui/material";
import { FontWeight } from "@smartrr/shared/entities/CustomerPortalTheme";
import { useI18NextResourceBundle } from "@customer-app/utils/useI18NextResourceBundle";

import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

export const useThemeOverrides = () => {
  const storeTheme = useSmartrrCustomerSelector(state => state.theme.theme);
  useI18NextResourceBundle(storeTheme.translationOverrides);

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        mdsm: 700,
      },
    },
    typography: {
      // Only supporting variants outlined in designs
      subtitle1: undefined,
      subtitle2: undefined,
      caption: undefined,
      overline: undefined,
    },
    ...storeTheme,
  });

  /* LARGE HEADING */
  theme.typography.h2 = {
    fontFamily: theme.modernLargeFontFamily,
    fontSize: "42px",
    fontWeight: "600",
    color: theme.modernLargeFontColor,
  };

  theme.typography.caption1 = {
    fontFamily: theme.modernCaptionFontFamily,
    fontSize: theme.modernCaptionFontSize + "px",
    fontWeight: (theme.modernCaptionFontWeight as FontWeight) || 500,
    lineHeight: theme.modernCaptionFontLineHeight + "px",
    letterSpacing: theme.modernCaptionFontLetterSpacing + "px",
    color: theme.modernCaptionFontColor,

    width: "max-content",
    margin: "0px",
  };
  return theme;
};
